import gutter from "../../../config/vars";
import Colors from "../../../config/colors";
export default {
  signStyles: {
    maxWidth: 340,
    width: 340,
    minWidth: 340,
    maxHeight: 468,
    height: 468,
    minHeight: 468,
    backgroundColor: Colors.dkgreen,
    float: "right",
    border: "10px solid #fff",
    marginRight: gutter,
    marginTop: "24px",
    opacity: ".85"
  },
  liStyle: {
    display: "inline",
    letterSpacing: ".02em",
    cursor: "pointer",

    fontSize: "15px",
    textTransform: "initial",

    opacity: 1,
    borderRight: "1px solid #fff",
    padding: "0px 16px"
  },
  liStyleRight: {
    display: "inline",
    terSpacing: ".02em",
    cursor: "pointer",

    fontSize: "16px",
    textTransform: "initial",

    opacity: 1,
    padding: "0px 16px"
  },
  ulStyle: {
    listStyle: "none",
    //        width:"111%",
    //        display: "block",
    margin: "32px 0 24px",
    borderBottom: "1px solid #fff",
    borderTop: "3px solid #fff",
    padding: "16px 35px"
    //        marginLeft:" -24px",
  },

  linkStyle: {
    textDecoration: "none",

    fontFamily: "Oswald",
    textTransform: "uppercase",
    fontWeight: "400",
    lineHeight: "1em",
    wordBreak: "break-word"
  }
};
